export default{
    footer: {},
    loading: false,
    error: ""
}